export default "__VITE_ASSET__DAmJhpyX__"